import { atom } from 'jotai';

export const messageAtom = atom('');
export const firstNameAtom = atom('');
export const phoneAtom = atom('');
export const emailAtom = atom('');

export const resetFlowAtom = atom(null, (_get, set) => {
  set(messageAtom, '');
  set(firstNameAtom, '');
  set(phoneAtom, '');
  set(emailAtom, '');
});
